import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import createSagaMiddleware from "redux-saga";
import saga from "./saga";

import logSlice from "./slices/logsSlice/logSlice";
import clientsListSlice from "./slices/clients/clientsListSlice";
import plansSlice from "./slices/plansSlice/plansSlice";
import profileSlice from "./slices/userSlices/profileSlice";

let sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["modals", "candidateCardsetList", "candidateForm", "candidates"],
};

const rootReducer = combineReducers({
  profile: profileSlice,
  appLogs: logSlice,
  clients: clientsListSlice,
  plans: plansSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const Store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(middleware),
});

sagaMiddleware.run(saga);

export const PersistorStore = persistStore(Store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof Store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof Store.dispatch;
